module.exports = __webpack_public_path__ + "img/3.5f453ca1.png";